import React from 'react';
import PropTypes from 'prop-types';
import './ColorSwatch.css';

/**
 * ColorSwatch — a small ringed colour dot beside a colour name (order lines,
 * cart lines, summaries). The ring (gray-3) keeps white readable on white.
 * Decorative unless `label` names the colour for assistive tech.
 */
const ColorSwatch = ({ color, label, size = 'm', className = '' }) => (
  <span
    className={['ds-color-swatch', `ds-color-swatch--${size}`, className].filter(Boolean).join(' ')}
    style={{ '--ds-color-swatch-color': color }}
    role={label ? 'img' : undefined}
    aria-label={label || undefined}
    aria-hidden={label ? undefined : 'true'}
  />
);

ColorSwatch.propTypes = {
  /** CSS colour — hex, rgb or a token */
  color: PropTypes.string.isRequired,
  /** Colour name for assistive tech; without it the dot is decorative */
  label: PropTypes.string,
  /** 's' 8px · 'm' 12px · 'l' 16px */
  size: PropTypes.oneOf(['s', 'm', 'l']),
  className: PropTypes.string,
};

export default ColorSwatch;
